import type { AuthContextType } from '@context/auth.context';
import type { ApiMessage } from '@interfaces/message';
import { apiRequest, isResponse } from '@services/fetcher';
import type { CursorPaginatedResponse } from '@utils/api/api-response';

export interface MessagesByDateMeta {
  anchor_message_id: number | null;
  resolved_at: string | null;
  resolved_date: string | null;
  selected_date: string;
  timezone: string;
  has_more_before: boolean;
  has_more_after: boolean;
}

export type MessagesByDateResponse = CursorPaginatedResponse<ApiMessage[], MessagesByDateMeta>;

async function fetchMessagesByDate(
  auth: AuthContextType,
  conversationId: number,
  selectedDate: string,
  timezone: string,
): Promise<MessagesByDateResponse> {
  const params = new URLSearchParams({
    conversationId: String(conversationId),
    selectedDate,
    timezone,
  });

  const url = `${import.meta.env.VITE_API_URL}/conversation/message/by-date?${params.toString()}`;
  const response = await apiRequest<MessagesByDateResponse>(url, auth);

  if (isResponse(response)) {
    throw new Error('Unexpected response');
  }

  if (response instanceof Error) {
    throw response;
  }

  return {
    ...response,
    data: response.data.map((message) => ({
      ...message,
      localId: message.id,
    })),
  };
}

export default fetchMessagesByDate;
